export default "__VITE_ASSET__aKo4wVjMjV9S8rY28E5Mvg__";